<template>
  <div class="bg-white">
    <div class="margin-bottom-sm flex align-center justify-between">
      <div class="flex align-center">
        <div class="flex align-center margin-right-sm">
          <span>通知标题：</span>
          <el-input v-model="searchName" placeholder="请输入通知名称" class="flex-sub"></el-input>
        </div>

        <el-button type="primary" @click="hanldSearch">搜索</el-button>
      </div>
      <el-button type="primary" @click="editItem(0)"  v-if="[3,5].includes(user.power)">发布通知</el-button>
    </div>
    <el-table
        :data="noticeList"
        header-row-class-name="table-header"
        row-class-name="table-row"
        alig="center"
        border
        style="width: 100%"
    >
      <el-table-column width="70" type="index" align="center" label="序号">
      </el-table-column>
      <el-table-column label="通知标题" prop="title"></el-table-column>
      <el-table-column width="150" label="更新时间" prop="update_time"></el-table-column>
      <el-table-column width="300" label="操作">
        <template slot-scope="scope">
          <div class="table-operate">

            <el-button
                size="small"
                type="primary"
                @click="showItem(scope.row.id)"
            >查看
            </el-button>
            <el-button
                 v-if="[3,5].includes(user.power)"
                size="small"
                type="primary"
                @click="editItem(scope.row.id)"
            >编辑
            </el-button>
            <el-button
                 v-if="[3,5].includes(user.power)"
                size="small"
                type="primary"
                @click="deleteItem(scope.row.id)"
            >删除
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        v-if="noticeList.length > 0"
        class="page-all"
        background
        @current-change="getNoticeList"
        :current-page.sync="page"
        :page-size="limit"
        layout="prev, pager, next, jumper"
        :total="total"
    >
    </el-pagination>

  </div>
</template>

<script>
import {noticeList,noticeDel} from "@/api/notice";
import {zhDate} from "@/utils/utils";

export default {
  name: "notice",
  data() {
    return {
      searchName: '',
      page: 1,
      limit: 10,
      total: 0,
      noticeList: [],
    }
  },
  created() {
    this.$emit("setIndex", this.$route.path, "通知公告", false);
    this.getNoticeList()
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  components: {},
  methods: {
    //  查看通知
    showItem(id) {
      this.$router.push('/home/notice-detail/' + id)
    },
    //  编辑通知
    editItem(id) {
      id ? this.$router.push('/home/notice-edit?id=' + id) : this.$router.push('/home/notice-edit')
    },
    //  删除通知
    deleteItem(id) {
      this.$confirm('您确定要删除该通知吗？', "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureDelete(id);
      });
    },
    async sureDelete(id) {
      let _state = await noticeDel(id);
      if (this.noticeList.length === 1 && this.page > 1) {
        this.page--;
      }
      this.getNoticeList();
      this.$message.success(_state.info);
    },
    //  搜索
    hanldSearch() {
      this.page = 1
      this.getNoticeList()
    },
    //  获取通知列表
    async getNoticeList() {
      let _list = await noticeList(this.searchName, this.page, this.limit)
      _list.data.map(item => {
        item.update_time = zhDate(item.update_time * 1000)
      })
      this.noticeList = _list.data
      this.total = _list.total_number
    },
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">

</style>
